<script lang="ts">
    import type { ShareableContainer } from '$lib/container/shareableContainer.js';
    import { setContainer } from '$components/Context/ContainerContext.js';

    export let container: ShareableContainer;

    setContainer(container);
</script>

<slot />
